import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const GET_CRITICAL_GEOMETRY_ARTIFACTS_QUERY_KEY = 'assets.getCriticalGeometryArtifacts';

export const useGetCriticalGeometryArtifacts = ({
  assetId,
  assetTenantId,
  enabled = true,
}: {
  assetId?: string;
  assetTenantId?: string;
  enabled?: boolean;
}) => {
  const { getTenantId } = useTenants();
  const tenantId = assetTenantId ?? getTenantId();

  const { data, isLoading } = useQuery({
    queryKey: [GET_CRITICAL_GEOMETRY_ARTIFACTS_QUERY_KEY, { assetId, tenantId }],
    queryFn: () => api.assets.listCriticalGeometryArtifacts(tenantId, assetId ?? ''),
    enabled: !!assetId && !!tenantId && enabled,
  });

  return {
    criticalGeometryArtifacts: data?.data.criticalGeometryArtifacts ?? [],
    isLoading,
  };
};
